module.exports = __webpack_public_path__ + "static/covid-7-7007f11d6227c2ac5f6486a6497386fc.png";